import { Grid, Typography } from '@mui/material';
import useMain from 'hooks/useMain';
import { useData } from 'pages/module/hook/useData';

const CusListLabelField = ({ fields, data, fieldKey, containerSpacing = 2, xs, sm, md, labelFieldKeyPrefix, ...gridContainerProps }) => {
  // fields => 'label id type'
  const { t } = useMain();
  const {
    rsCompanyOptions,
    supplierOptions,
    concreteOptions,
    categoryOptions,
    subCategoryOptions,
    bcTypeOptions,
    blockOptions,
    floorOptions,
    unitOptions
  } = useData({});

  return (
    <Grid container spacing={containerSpacing} {...gridContainerProps}>
      {!_.isEmpty(fields) &&
        _.map(fields, (currValue, index) => {
          let fieldValue = data[currValue[fieldKey]];

          if (_.isEqual(currValue?.type, 'checkbox')) {
            fieldValue = _.isEqual(fieldValue, 0) ? 'N' : 'Y';
          }
          if (_.isEqual(currValue?.id, 'RoomId')) {
            let options = _.find(unitOptions, ({ value }) => _.isEqual(value, fieldValue));
            fieldValue = options?.label;
          }
          if (_.isEqual(currValue?.id, 'RscompanyId')) {
            let options = _.find(rsCompanyOptions, ({ value }) => _.isEqual(value, fieldValue));
            fieldValue = options?.label;
          }
          if (_.isEqual(currValue?.id, 'SupplierId')) {
            //
            let options = _.find(supplierOptions, ({ value }) => _.isEqual(value, fieldValue));
            fieldValue = options?.label;
          }
          // if (_.isEqual(currValue?.id, 'CategoryId')) {
          //   let options = _.find(categoryOptions, ({value}) => _.isEqual(value,fieldValue))
          //   fieldValue = options?.label;
          // }
          // if (_.isEqual(currValue?.id, 'SubCategoryId')) {
          //   let options = _.find(subCategoryOptions, ({value}) => _.isEqual(value,fieldValue))
          //   fieldValue = options?.label;
          // }
          // if (_.isEqual(currValue?.id, 'ConcreteId')) {
          //   let options = _.find(concreteOptions, ({value}) => _.isEqual(value,fieldValue))
          //   fieldValue = options?.label;
          // }
          return (
            <Grid item xs={xs} sm={sm} md={md} key={`${labelFieldKeyPrefix}-${index}`}>
              <Typography variant="body1" mb={1} sx={{ color: '#bfbfbf' }}>
                {t(currValue?.label)}
              </Typography>
              <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
                {fieldValue ?? '_'}
              </Typography>
            </Grid>
          );
        })}
    </Grid>
  );
};

export default CusListLabelField;
